<template>
    <div class="">
        <UserCabinetMenu v-if="authenticationStatus" :typeSmall="typeSmall"></UserCabinetMenu>
        <UserIsNotLogin v-else :typeSmall="typeSmall"></UserIsNotLogin>
    </div>
</template>

<script>
    import { mapState } from 'vuex';
    import UserIsNotLogin from "./UserIsNotLogin";
    import UserCabinetMenu from "./UserCabinetMenu";

    export default {
        name: "UserCabinet",

        components: {
            UserCabinetMenu,
            UserIsNotLogin,
        },

        props: [
            'typeSmall',
        ],

        computed: {
            ...mapState('authentication', [
                'authenticationStatus',
            ]),
        },

    }
</script>

<style scoped>
    .cabinet {
        margin: 0 5px;
    }
</style>